import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-base font-bold text-gray-900 dark:text-white mb-3">{title}</h2>
    <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2 leading-relaxed">{children}</div>
  </div>
);

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 mb-6"
        >
          <ChevronLeft className="w-4 h-4" /> 뒤로가기
        </button>

        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">개인정보 처리방침</h1>
        <p className="text-xs text-gray-400 mb-8">시행일: 2026년 3월 20일</p>

        <p className="text-sm text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
          티앤티 주식회사(이하 "회사")는 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다.
        </p>

        <Section title="제1조 (개인정보의 처리 목적)">
          <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행합니다.</p>
          <p className="pl-4">1. 서비스 가입 및 관리: 회원 가입 의사 확인, 회원 식별·인증, 회원자격 유지·관리</p>
          <p className="pl-4">2. 서비스 제공: 헬스장 회원 관리, 회원권·PT 관리, 출석 관리 등 서비스 기능 제공</p>
          <p className="pl-4">3. 고충 처리: 민원 처리, 분쟁 조정을 위한 기록 보존</p>
        </Section>

        <Section title="제2조 (처리하는 개인정보 항목)">
          <p>회사는 다음의 개인정보 항목을 처리합니다.</p>
          <p className="font-medium mt-2">① 관리자 계정(헬스장 운영자)</p>
          <p className="pl-4">필수: 이름, 이메일 주소, 비밀번호(암호화 저장)</p>
          <p className="font-medium mt-2">② 회원 계정(헬스장 이용 회원)</p>
          <p className="pl-4">필수: 이름, 전화번호, 비밀번호(암호화 저장)</p>
          <p className="pl-4">선택: 성별, 생년월일, 주소, 운동 목적, 프로필 사진</p>
          <p className="font-medium mt-2">③ 서비스 이용 과정에서 자동 생성·수집되는 정보</p>
          <p className="pl-4">서비스 이용 기록, 접속 로그</p>
        </Section>

        <Section title="제3조 (개인정보의 처리 및 보유 기간)">
          <p>① 회사는 법령에 따른 개인정보 보유·이용 기간 또는 이용자로부터 개인정보를 수집 시에 동의받은 보유·이용 기간 내에서 개인정보를 처리합니다.</p>
          <p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
          <p className="pl-4">1. 서비스 가입 및 관리: 회원 탈퇴 시까지 (단, 법령에 의한 보존 의무가 있는 경우 해당 기간까지)</p>
          <p className="pl-4">2. 전자상거래 관련 기록: 「전자상거래 등에서의 소비자보호에 관한 법률」에 따라 5년간 보존</p>
        </Section>

        <Section title="제4조 (개인정보의 제3자 제공)">
          <p>① 회사는 이용자의 개인정보를 제2조에서 명시한 목적 범위 내에서만 처리하며, 이용자의 동의 없이 목적 외의 용도로 처리하거나 제3자에게 제공하지 않습니다.</p>
          <p>② 다만, 다음의 경우에는 예외로 합니다.</p>
          <p className="pl-4">1. 법령의 규정에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>
        </Section>

        <Section title="제5조 (개인정보 처리 위탁)">
          <p>① 회사는 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁하고 있습니다.</p>
          <p className="pl-4">- 수탁자: Supabase Inc.</p>
          <p className="pl-4">- 위탁 업무: 데이터베이스 운영 및 인증 서비스</p>
          <p>② 회사는 위탁 계약 체결 시 관련 법령에 따라 위탁업무 수행 목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한 등을 규정합니다.</p>
        </Section>

        <Section title="제6조 (정보주체의 권리·의무 및 행사 방법)">
          <p>① 이용자는 회사에 대해 언제든지 다음 각 호의 권리를 행사할 수 있습니다.</p>
          <p className="pl-4">1. 개인정보 열람 요구</p>
          <p className="pl-4">2. 오류 등이 있을 경우 정정 요구</p>
          <p className="pl-4">3. 삭제 요구</p>
          <p className="pl-4">4. 처리 정지 요구</p>
          <p>② 권리 행사는 이메일(ezbiz.manager@gmail.com)을 통해 하실 수 있으며, 회사는 지체 없이 조치하겠습니다.</p>
        </Section>

        <Section title="제7조 (개인정보의 파기)">
          <p>① 회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
          <p>② 전자적 파일 형태의 정보는 기술적 방법을 사용하여 복구 불가능하게 삭제합니다.</p>
        </Section>

        <Section title="제8조 (개인정보의 안전성 확보 조치)">
          <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
          <p className="pl-4">1. 비밀번호의 암호화: 이용자의 비밀번호는 암호화하여 저장·관리</p>
          <p className="pl-4">2. 해킹 등에 대비한 기술적 대책: SSL 인증서 적용 등 보안 프로토콜 사용</p>
          <p className="pl-4">3. 접근 권한 관리: 개인정보를 처리하는 시스템에 대한 접근 권한 최소화</p>
        </Section>

        <Section title="제9조 (개인정보 보호책임자)">
          <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지는 개인정보 보호책임자를 다음과 같이 지정하고 있습니다.</p>
          <p className="mt-2 pl-4">이메일: ezbiz.manager@gmail.com</p>
          <p className="pl-4">처리 기한: 10일 이내</p>
        </Section>

        <Section title="제10조 (개인정보 처리방침의 변경)">
          <p>이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경 사항의 시행 7일 전부터 공지사항을 통해 고지합니다.</p>
        </Section>

        <div className="mt-8 p-4 bg-gray-100 dark:bg-gray-800 rounded-xl text-sm text-gray-600 dark:text-gray-400 space-y-1">
          <p className="font-medium text-gray-900 dark:text-white">티앤티 주식회사 (TNT Inc.)</p>
          <p>충북 충주시 호암토성2로3, 707호 (27480)</p>
          <p>사업자등록번호: 105-88-17712</p>
          <p>이메일: ezbiz.manager@gmail.com</p>
        </div>
      </div>
    </div>
  );
}
